import React from 'react';
import { styled } from 'styled-components';
import { PacmanLoader } from 'react-spinners';

const LoadingBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 100;
  backdrop-filter: blur(4px);

  background-color: rgba(44, 44, 44, 0.2);
`;

const Loading = () => {
    return (
        <LoadingBox>
                <PacmanLoader
                loading={true}
                color="#165BAA"
                size={32} />
        </LoadingBox>
    );
};

export default Loading;